<template lang='pug'>
  i.svg-icon.svg-icon-bookmark
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
       path(d='M11.763,96.879c0-24.777,0-49.555,0-74.333c0.063-0.058,0.159-0.105,0.187-0.175 c1.161-2.991,2.651-3.969,6.065-3.971c2.988-0.001,5.977,0.002,8.965-0.004c0.399,0,0.798-0.05,1.25-0.08 c0.029-0.414,0.072-0.748,0.073-1.082c0.006-2.824,0.025-5.648-0.003-8.473c-0.027-2.608,1.03-4.559,3.722-5.584 c0.074-0.029,0.124-0.118,0.185-0.179c17.497,0,34.995,0,52.494,0c1.97,0.935,3.356,2.318,3.867,4.372c0,24.521,0,49.041,0,73.561 c-0.725,1.272-1.116,1.382-2.469,0.691c-0.163-0.083-0.317-0.173-0.476-0.258c-4.073-2.164-8.145-4.328-12.219-6.492 c-0.419-0.223-0.846-0.435-1.424-0.73c0,0.682,0,1.151,0,1.619c0,6.6,0.005,13.198-0.006,19.797 c-0.003,0.615,0.252,1.358-0.522,1.742c-0.787,0.392-1.495,0.149-2.138-0.389c-0.271-0.224-0.629-0.354-0.946-0.524 c-7.542-4.021-15.081-8.044-22.62-12.063c-1.271-0.679-2.548-1.347-3.846-2.031c-0.445,0.229-0.848,0.429-1.243,0.64 c-8.73,4.668-17.465,9.329-26.184,14.017C13.508,97.471,12.644,97.74,11.763,96.879z M22.529,81.186 c0.698-0.351,1.226-0.601,1.74-0.876c5.148-2.742,10.314-5.455,15.429-8.251c1.527-0.835,2.847-0.844,4.374-0.011 c5.238,2.856,10.521,5.639,15.79,8.446c0.425,0.228,0.866,0.431,1.414,0.703c0-17.716,0-35.293,0-52.868 c-12.968,0-25.833,0-38.747,0C22.529,45.94,22.529,63.458,22.529,81.186z M77.77,65.813c0-17.713,0-35.213,0-52.768 c-12.946,0-25.805,0-38.714,0c0,1.802,0,3.534,0,5.355c0.605,0,1.106,0,1.607,0c8.237,0,16.474-0.001,24.709,0.002 c0.597,0,1.198-0.007,1.791,0.051c2.431,0.241,4.061,1.575,4.586,3.802c0.166,0.703,0.222,1.44,0.224,2.162 c0.014,12.294,0.009,24.588,0.009,36.882c0,0.506,0,1.01,0,1.462C73.951,63.8,75.784,64.766,77.77,65.813z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>